<template>
    <div class="platformReport">
        <div>
            <el-radio-group>
                <el-radio-button>平台总报表</el-radio-button>
            </el-radio-group>
        </div>
        <div class="content-block">
            <div class="cb-item">
                <el-card class="box-card cbi-c">
                    <div slot="header" class="clearfix">
                        <el-button type="text" @click="getJPHistory"  size="medium" class="color-blue">平台总收入</el-button>
                        <strong type="text" style="float:right;color: #04be02"
                                v-text="`${numberChip(platformReportInfo.collectFeeTotal+platformReportInfo.collectJPTotal
                                +platformReportInfo.buyExpression+platformReportInfo.collectHorseRaceLampTotal+platformReportInfo.buyDelay
                                +platformReportInfo.buyVip+platformReportInfo.withdrawalFee+platformReportInfo.aiWinTotal
                                +platformReportInfo.insuranceProfitTotal)}`"></strong>
                    </div>
                    <div class="text item">
                        <table>
                            <tr>
                              <td style="width:150px">收取服务费：</td>
                              <td v-text="`${numberChip(platformReportInfo.collectFeeTotal)}`"></td>
                              <td style="width:200px" >投入JackPot金额：</td>
                              <td v-text="`${numberChip(platformReportInfo.collectJPTotal)}`"></td>
                            </tr>
                          <tr>
                            <td style="width:200px" >购买表情包总额：</td>
                            <td v-text="`${numberChip(platformReportInfo.buyExpression)}`"></td>
                            <td style="width:200px" >投入跑马灯金额：</td>
                            <td v-text="`${numberChip(platformReportInfo.collectHorseRaceLampTotal)}`"></td>
                          </tr>
                          <tr>
                            <td style="width:200px" >购买延迟总额：</td>
                            <td v-text="`${numberChip(platformReportInfo.buyDelay)}`"></td>
                            <td style="width:200px" >购买VIP总额：</td>
                            <td v-text="`${numberChip(platformReportInfo.buyVip)}`"></td>
                          </tr>
                          <tr>
                            <td style="width:200px" >用户提现手续费总额：</td>
                            <td v-text="`${numberChip(platformReportInfo.withdrawalFee)}`"></td>
                            <td style="width:200px" >AI用户赢取总额：</td>
                            <td v-text="`${numberChip(platformReportInfo.aiWinTotal)}`"></td>
                          </tr>
                          <tr>
                            <td style="width:200px" >投入保险池：</td>
                            <td v-text="`${numberChip(platformReportInfo.insuranceProfitTotal)}`"></td>
                            <td  style="width:150px">获取JP服务费：</td>
                            <td v-text="`${numberChip(platformReportInfo.jpWinFee)}`"></td>
                          </tr>
                        </table>
                    </div>
                </el-card>
                 <el-card class="box-card cbi-c">
                    <div slot="header" class="clearfix">
                      <el-button type="text" @click="getJPHistory"  size="medium" class="color-blue">平台总支出</el-button>
                      <strong type="text" style="float:right;color: #e53935" v-text="`${numberChip(platformReportInfo.winFeeRebate
                      +platformReportInfo.insuranceRebate+platformReportInfo.jpUserWin+platformReportInfo.jpWinRebate
                      +platformReportInfo.horseRaceLampWin+platformReportInfo.insuranceExpenditureTotal+platformReportInfo.agentFee
                      +platformReportInfo.aiFailTotal)}`" disabled></strong>
                    </div>
                    <div class="text item">
                        <table>
                            <tr>
                                <td  style="width:150px">服务费总返佣：</td>
                                <td v-text="`${numberChip(platformReportInfo.winFeeRebate)}`"></td>
                              <td  style="width:150px">保险总返佣：</td>
                              <td v-text="`${numberChip(platformReportInfo.insuranceRebate)}`"></td>
                            </tr>
                          <tr>
                            <td  style="width:150px">JackPot中奖：</td>
                            <td v-text="`${numberChip(platformReportInfo.jpUserWin)}`"></td>
                            <td  style="width:150px">JackPot总返佣：</td>
                            <td v-text="`${numberChip(platformReportInfo.jpWinRebate)}`"></td>
                          </tr>
                          <tr>
                            <td  style="width:150px">跑马灯中奖：</td>
                            <td v-text="`${numberChip(platformReportInfo.horseRaceLampWin)}`"></td>
                            <td  style="width:150px">保险总赔付：</td>
                            <td v-text="`${numberChip(platformReportInfo.insuranceExpenditureTotal)}`"></td>
                          </tr>
                          <tr>
                            <td  style="width:150px">无限代：</td>
                            <td v-text="`${numberChip(platformReportInfo.agentFee)}`"></td>
                            <td  style="width:150px">AI用户支出：</td>
                            <td v-text="`${numberChip(platformReportInfo.aiFailTotal)}`"></td>
                          </tr>
                        </table>
                    </div>
                </el-card>
            </div>
            <div class="cb-item">
              <el-card class="box-card cbi-c">
                <div slot="header" class="clearfix">
                  <el-button type="text" @click="getInsurer"  size="medium" class="color-blue">保险数据</el-button>
                </div>
                <div class="text item">
                  <table>
                    <tr>
                      <td style="width:150px">保险池收益：</td>
                      <td  v-text="`${numberChip(platformReportInfo.insuranceProfitTotal)}`"></td>
                      <td>保险池支出：</td>
                      <td v-text="`${numberChip(platformReportInfo.insuranceExpenditureTotal)}`"></td>
                    </tr>

                    <tr>
                      <td  style="width:150px">俱乐部保险收益:</td>
                      <td v-text="`${numberChip(platformReportInfo.insuranceClubRebate)}`"></td>
                      <td style="width:150px">联盟保险收益:</td>
                      <td v-text="`${numberChip(platformReportInfo.insuranceTribeRebate)}`"></td>
                    </tr>
                  </table>
                </div>
              </el-card>
              <el-card class="box-card cbi-c">
                <div slot="header" class="clearfix">
                  <el-button type="text" @click="getJPHistory"  size="medium" class="color-blue">JackPot数据</el-button>
                </div>
                <div class="text item">
                  <table>
                    <tr>
                      <td style="width:150px">投入JackPot池总额：</td>
                      <td v-text="`${numberChip(platformReportInfo.collectJPTotal)}`"></td>
                      <td>投入系统池总额：</td>
                      <td v-text="`${numberChip(platformReportInfo.collectSystemTotal)}`"></td>
                    </tr>

                    <tr>
                      <td  style="width:180px">中得JackPot返佣总额：</td>
                      <td v-text="`${numberChip(platformReportInfo.jpWinRebate)}`"></td>
                      <td style="width:180px">中得JackPot总额：</td>
                      <td v-text="`${numberChip(platformReportInfo.jpUserWin)}`"></td>
                    </tr>
                  </table>
                </div>
              </el-card>
              <el-card class="box-card cbi-c">
                    <div slot="header" class="clearfix">
                      <el-button type="text" @click="getJPHistory"  size="medium" class="color-blue">跑马灯数据</el-button>
                    </div>
                    <div class="text item">
                        <table>
                            <tr>
                                <td style="width:150px">投入跑马灯总金额：</td>
                                <td v-text="`${numberChip(platformReportInfo.collectHorseRaceLampTotal)}`"></td>
                                <td>中得跑马灯总金额：</td>
                                <td v-text="`${numberChip(platformReportInfo.horseRaceLampWin)}`"></td>
                            </tr>
                        </table>
                    </div>
                </el-card>
            </div>
            <div class="cb-item">
                <el-card class="box-card cbi-c">
                    <div slot="header" class="clearfix">
                      <el-button type="text" @click="getUserIntegral"  size="medium" class="color-blue">玩家积分</el-button>
                    </div>
                    <div class="text item">
                        <table>
                            <tr>
                                <td style="width:150px">总输赢积分：</td>
                                <td v-text="`${numberChip(platformReportInfo.winTotal)}`"></td>
                            </tr>
                            <tr>
                                <td>用户总输赢积分：</td>
                                <td v-text="`${numberChip(platformReportInfo.userWinTotal)}`"></td>
                                <td>AI总输赢积分：</td>
                                <td v-text="`${numberChip(platformReportInfo.aiWinTotal-platformReportInfo.aiFailTotal)}`"></td>
                            </tr>
                        </table>
                    </div>
                </el-card>
                <el-card class="box-card cbi-c">
                <div slot="header" class="clearfix">
                  <el-button type="text" @click="getJPHistory"  size="medium" class="color-blue">用户服务费数据</el-button>
                </div>
                <div class="text item">
                  <table>
                    <tr>
                      <td>平台获取服务费：</td>
                      <td v-text="`${numberChip(platformReportInfo.collectFeeTotal)}`"></td>
                    </tr>
                    <tr>
                      <td>俱乐部用户返利额：</td>
                      <td v-text="`${numberChip(platformReportInfo.clubFeeRebate)}`"></td>
                      <td>联盟用户返利额：</td>
                      <td v-text="`${numberChip(platformReportInfo.tribeFeeRebate)}`"></td>
                    </tr>
                  </table>
                </div>
              </el-card>
                <el-card class="box-card cbi-c">
                  <div slot="header" class="clearfix">
                    <el-button type="text" @click="getJPHistory"  size="medium" class="color-blue">现金流水数据</el-button>
                  </div>
                  <div class="text item">
                    <table>
                      <tr>
                        <td style="width:150px">用户充值总额：</td>
                        <td v-text="`${numberChip(platformReportInfo.userRecharge)}`"></td>
                        <td  style="width:180px">用户提现总额：</td>
                        <td v-text="`${numberChip(platformReportInfo.userWithdrawal)}`"></td>
                      </tr>
                    </table>
                  </div>
                </el-card>
            </div>
          <div class="cb-item">
            <el-card class="box-card cbi-c">
              <div slot="header" class="clearfix">
                <el-button type="text" @click="getUserIntegral"  size="medium" class="color-blue">德州牛仔</el-button>
              </div>
              <div class="text item">
                <table>
                  <tr>
                    <td style="width:150px">玩家总输赢：</td>
                    <td v-text="`${numberChip(platformReportInfo.winChip)}`"></td>
                    <td style="width:150px">平台对赌仓：</td>
                    <td v-text="`${numberChip(platformReportInfo.adminChip)}`"></td>
                  </tr>
                  <tr>
                    <td>俱乐部返佣：</td>
                    <td v-text="`${numberChip(platformReportInfo.clubRebateChip)}`"></td>
                    <td>联盟返佣：</td>
                    <td v-text="`${numberChip(platformReportInfo.recordsRebateChip)}`"></td>
                  </tr>
                </table>
              </div>
            </el-card>
            <el-card class="box-card cbi-c">
              <div slot="header" class="clearfix">
                <el-button type="text" @click="getUserIntegral"  size="medium" class="color-blue">百人德州</el-button>
              </div>
              <div class="text item">
                <table>
                  <tr>
                    <td style="width:150px">玩家总输赢：</td>
                    <td v-text="`${numberChip(platformReportInfo.winChipBRDZ)}`"></td>
                    <td style="width:150px">平台对赌仓：</td>
                    <td v-text="`${numberChip(platformReportInfo.adminChip)}`"></td>
                  </tr>
                  <tr>
                    <td>俱乐部返佣：</td>
                    <td v-text="`${numberChip(platformReportInfo.clubRebateChipBRDZ)}`"></td>
                    <td>联盟返佣：</td>
                    <td v-text="`${numberChip(platformReportInfo.recordsRebateChipBRDZ)}`"></td>
                  </tr>
                  <tr>
                    <td style="width:150px">彩金池：</td>
                    <td v-text="`${numberChip(platformReportInfo.jackpotSumChipBRDZ)}`"></td>
                    <td style="width:150px">中彩金额：</td>
                    <td v-text="`${numberChip(platformReportInfo.jackpotChipBRDZ)}`"></td>
                  </tr>
                  <tr>
                    <td style="width:150px">抽水金额：</td>
                    <td v-text="`${numberChip(platformReportInfo.taxNumBRDZ)}`"></td>
                    <td style="width:150px">抽水比例：</td>
                    <td v-text="`${numberChip(platformReportInfo.taxBRDZ)}%`"></td>
                  </tr>
                </table>
              </div>
            </el-card>
            <el-card class="box-card cbi-c">
            </el-card>
          </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                date:'',
            }
        },
        computed: {
            ...mapState('platformReport', ['platformReportInfo'])
        },
        created() {
            this.getReportInfo(0);
        },
        methods:{
            ...mapActions('platformReport', ['getPlatformReportInfo']),
            getJPHistory(){
             this.$router.push('./JPTotal')
            },
            getHorseRaceLampContribution(){
              this.$router.push('./horseRaceLampTotal')
            },
          getSystemFee(){
            this.$router.push('./omsUserFee')
          },
          getUserIntegral(){
            this.$router.push('./integral')
          },
          getInsurer(){
            this.$router.push('./insurerFee')
          },
          numberChip(val){
              return val/100;
          },
            getReportInfo(){
                this.getPlatformReportInfo().then(() => {
                    this.$message.success('获取成功');
                })
            }
        }
    }
</script>
<style lang="scss">
    .platformReport{
        .condition-block{
            text-align: right;
            .btn{
                margin-left: 10px;
            }
        }
        .content-block{
            .cb-item{
                display: flex;
                justify-content: space-between;
                margin: 30px 0;
                .cbi-c{
                    width: 48%;
                    .color-blue{
                        color:#03A9F4;
                    }
                    .item{
                        table{
                            width: 100%;
                        }
                    }
                }
            }
        }
    }
</style>
